import React from 'react'

import classNames from 'classnames'

import { StockInformation } from 'src/apollo/onlineOrdering'
import { t } from 'src/translations'
import { StockIcon } from 'public/components/default_template/product_display/ecommerce_product_display/stock/StockIcon'

/**
 * Displays stock status for a specific restaurant location
 * Looks up stock data by restaurantGuid and shows in-stock/out-of-stock indicator
 */
export const LocationStockStatus = ({
  restaurantGuid,
  stockData
}: {
  restaurantGuid: string
  stockData: StockInformation[]
}) => {
  // ChangeLocationModal filters out locations without stock info
  const outOfStock =
    stockData.find((stock) => stock.restaurantGuid === restaurantGuid)
      ?.outOfStock ?? false

  return (
    <div className='locationStockStatus'>
      <StockIcon outOfStock={outOfStock} />
      <span className={classNames('stockMessage', { outOfStock })}>
        {outOfStock
          ? t('product-display.change-location-modal.out-of-stock')
          : t('product-display.change-location-modal.in-stock')}
      </span>
    </div>
  )
}
